import Logo from '../../images/HRBMainLogo.png'
import './style.css';
import AssignmentBlock from '../Controls/assignmentBlock'
import WorkflowActions from '../../reducers/workflowRedux'

const OuterLogoAssignment = props => {
    const handleScheduleCallClick = (taxYear) => {
        dispatch(WorkflowActions.scheduleCallAttempt(taxYear))
    }

    return (
        <div className='outerLogoAssignmentContainer'>
            <div className='outerLogoAssignmentContainerLogo'>
                <img src={Logo} width={props.layoutType === 'desktop' ? '133px' : '116px'}  height={props.layoutType === 'desktop' ? '133px' : '116px'}/>
            </div>
            <AssignmentBlock scheduleCallClick={handleScheduleCallClick}
                layoutType={props.layoutType} loaded={props.loaded} />
        </div>
    )
}

export default OuterLogoAssignment